const dataManager = {
  "data-mgmt": {
    dialog: {
      node: {
        title: "単位・欠損補完・アプリ表示設定",
        desc: "アップロードしたデータ項目の単位、単位名、データのタイプ、アプリへの表示を設定します。設定完了後は保存ボタンを押してください。",
        next: "設定する",
      },
      discretize: {
        title: "因果推論データ設定",
        desc: "最初に離散化レベル値を設定し、手動の場合は各レベルの境界となる値を決定します。\n因果階層設定では、同じ層、数字の大きな層への因果のみを許可します。\n設定完了後は保存ボタンを押してください。",
        next: "設定する",
      },
    },
  },

  // SHARED
  "data-mgmt-reload-api-success": "データの最新化が正常に行われました。",
  "data-mgmt-reload-api-loading": "データの最新化中です。",
  "data-mgmt-reload-api-error": "データの最新化に失敗しました。",

  // MAIN
  "data-mgmt-main-title": "データ管理",
  "data-mgmt-main-description":
    "このページでは、データに関する設定などを管理することができます。",

  "data-mgmt-main-tab1": "識別コード",
  "data-mgmt-main-tab2": "ノード",
  "data-mgmt-main-tab3": "事前ルール",
  "data-mgmt-main-tab4": "グループ",

  "data-mgmt-main-button2": "CSVチェッカーダウンロード",
  "data-mgmt-main-button3": "アップロード",
  "data-mgmt-main-tooltip": "権限が不足しています",

  // SUMMARY
  "data-mgmt-summary-widget1-title": "データ容量",
  "data-mgmt-summary-widget2-title": "有効識別コード数",
  "data-mgmt-summary-widget4-title": "データ期間",
  "data-mgmt-summary-widget5-title": "最終アップロード日時",

  // UPLOAD
  "data-mgmt-upload-dialog-title": "1. データアップロード",
  "data-mgmt-upload-dialog-desc":
    "このセクションでは選択したデータを一時的にアップロードします。",

  "data-mgmt-upload-dialog-tab1": "追加",
  "data-mgmt-upload-dialog-tab1-description":
    "以前アップロードされたデータに新たに追加されます。",
  "data-mgmt-upload-dialog-tab2": "新規",
  "data-mgmt-upload-dialog-tab2-desc":
    "以前アップロードされたすべてのデータが削除されます。",

  "data-mgmt-upload-dialog-support1": "ドラッグ&ドロップ もしくは",
  "data-mgmt-upload-dialog-support2": "ファイル選択",
  "data-mgmt-upload-dialog-support3": "サポートフォーマット",

  "data-mgmt-upload-dialog-limit1": "ファイル数制限",
  "data-mgmt-upload-dialog-limit2": "ファイル容量制限",
  "data-mgmt-upload-dialog-submit1": "アップロード",
  "data-mgmt-upload-dialog-submit2": "アップロード中...",

  "data-mgmt-upload-dialog-size-over": "利用可能な合計データサイズを超えています",
  "data-mgmt-upload-dialog-size-alert": "合計データサイズが容量制限に達しそうです（残り",
  "data-mgmt-upload-dialog-size-alert2": "）。ご注意ください。",

  "data-mgmt-upload-dialog-toast-error1": "ファイルが選択されていません。",
  "data-mgmt-upload-dialog-toast-error2": "データアップロードに失敗しました。",
  
  "data-mgmt-upload-csv-checker-checkbox": "CSVチェッカーで検証済のCSV(出力ファイル)をアップロードします。",
  "data-mgmt-upload-csv-checker-note-1": "※ CSVチェッカーはアップロードボタンの左の",
  "data-mgmt-upload-csv-checker-note-2": "からダウンロードできます。",
  "data-mgmt-upload-csv-checker-label": "CSVチェッカーで検証済のファイルを使用する",

  // SUBJECT ATTRIBUTE (ステップ2)
  "data-mgmt-attr-step-title": "2. 層別化属性の設定",
  "data-mgmt-attr-step-dialog-desc":
    "このセクションでは層別化解析に使う属性の項目を選択します。",
  "data-mgmt-attr-step-desc":
    "層別化解析に使う属性を2つ選択してください（文字列の項目は自動選択されます）。",
  "data-mgmt-attr-step-type-integer": "整数",
  "data-mgmt-attr-step-type-float": "小数",
  "data-mgmt-attr-step-type-string": "文字列",
  "data-mgmt-attr-step-type-other": "その他",
  "data-mgmt-attr-step-distinct": "種類数",
  "data-mgmt-attr-step-truncated": "（頻度上位のみ表示）",
  "data-mgmt-attr-step-selected": "選択中の層別化属性",
  "data-mgmt-attr-step-submit": "決定",
  "data-mgmt-attr-step-submitting": "設定中 ...",
  "data-mgmt-attr-step-toast-error": "層別化属性の設定に失敗しました。",
  "data-mgmt-attr-step-too-few":
    "属性候補となる項目（整数／文字列）が2つ以上必要です。CSVを再度アップロードしてください。",
  "data-mgmt-attr-step-too-many-strings":
    "文字列項目が3つ以上あります。属性は最大2つまでで、文字列項目はすべて属性として指定する必要があります。CSVを再度アップロードしてください。",

  // 取込のキャンセル (アップロードの中止)。ステップ2/3 で共通。
  "data-mgmt-ingest-cancel": "キャンセル",
  "data-mgmt-ingest-cancelling": "中止中 ...",
  "data-mgmt-ingest-cancel-toast-success": "アップロードを中止しました。",
  "data-mgmt-ingest-cancel-toast-error": "アップロードの中止に失敗しました。",

  // TIME GRAIN (ステップ3)
  "data-mgmt-grain-step-title": "3. 時間粒度の設定",
  "data-mgmt-grain-step-dialog-desc":
    "このセクションでは生成する時間粒度を選択します。",
  "data-mgmt-grain-step-desc":
    "集計する時間粒度を選択してください（複数可）。検出値より細かい粒度は選べません。",
  "data-mgmt-grain-step-detected": "検出値",
  "data-mgmt-grain-step-submit": "決定",
  "data-mgmt-grain-step-submitting": "設定中 ...",
  "data-mgmt-grain-step-toast-error": "時間粒度の設定に失敗しました。",

  // 時間粒度の自動確定 (旧ステップ3 の置き換え)。フォールバックは無く、閉じると取込を中止する。
  "data-mgmt-grain-auto-error-title": "時間粒度の設定に失敗しました",
  "data-mgmt-grain-auto-error-close": "閉じる",
  "data-mgmt-grain-auto-error-no-enabled": "ベンダーの時間粒度設定が空のため、データ追加の取込を続行できません。\nアップロードを中止します。管理者にお問い合わせください。",
  "data-mgmt-grain-auto-error-no-finest": "アップロードしたデータから最小の時間粒度を検出できませんでした。\nアップロードを中止します。管理者にお問い合わせください。",
  "data-mgmt-grain-auto-error-failed": "時間粒度の自動設定に失敗しました。\nアップロードを中止します。時間をおいて再度お試しください。",

  // 時間粒度 (grain key) の表示名。GRAIN_OPTIONS の全 key ぶん用意する。
  "data-mgmt-grain-key-nanosec": "ナノ秒",
  "data-mgmt-grain-key-microsec": "マイクロ秒",
  "data-mgmt-grain-key-millisec": "ミリ秒",
  "data-mgmt-grain-key-sec": "秒",
  "data-mgmt-grain-key-min": "分",
  "data-mgmt-grain-key-hour": "時",
  "data-mgmt-grain-key-quarter_day": "四半日",
  "data-mgmt-grain-key-day": "日",
  "data-mgmt-grain-key-week": "週",
  "data-mgmt-grain-key-month": "月",
  "data-mgmt-grain-key-quarter_year": "四半年",
  "data-mgmt-grain-key-year": "年",


  // STORE
  "data-mgmt-store-dialog-title": "3. アップロードデータの有効化",
  "data-mgmt-store-dialog-title-legacy": "2. アップロードデータの有効化",
  "data-mgmt-store-dialog-desc":
    "このセクションではアップロードされたデータの有効化、無効化を選択できます。",

  "data-mgmt-store-dialog-widget1": "データ容量",
  "data-mgmt-store-dialog-widget1-error": "データ容量の制限を超えました。",
  "data-mgmt-store-dialog-widget2": "有効識別コード数",
  "data-mgmt-store-dialog-widget2-error":
    "有効識別コード数の制限を超えました。",
  "data-mgmt-store-dialog-widget3": "ファイル制限",

  "data-mgmt-store-dialog-submit1": "無効化",
  "data-mgmt-store-dialog-submit2": "無効化中 ...",
  "data-mgmt-store-dialog-submit3": "有効化",
  "data-mgmt-store-dialog-submit4": "有効化中 ...",
  "data-mgmt-store-dialog-analyzing":
    "データを解析しています。完了すると取込を実行できます。",

  "data-mgmt-store-dialog-toast-success1": "キューに追加されました。",
  "data-mgmt-store-dialog-toast-success2": "データの有効化が完了しました",
  "data-mgmt-store-dialog-toast-success3": "データの無効化が完了しました",
  "data-mgmt-store-dialog-toast-error1": "ファイルが選択されていません。",
  "data-mgmt-store-dialog-toast-error2": "データの有効化に失敗しました。",
  "data-mgmt-store-dialog-toast-error3": "データの無効化に失敗しました。",
  "data-mgmt-store-dialog-toast-error4":
    "選択可能なファイル数上限を超えました。",

  // NODE
  "data-mgmt-node-toolbar": "ノード",
  "data-mgmt-node-discretize-toolbar": "因果推論データ設定",

  "data-mgmt-node-widget-numbers": "各項目数",
  "data-mgmt-node-widget-data-range": "データ期間",
  "data-mgmt-node-widget-uploaded-date": "最終アップロード日時",
  "data-mgmt-node-widget-numbers-unit1": "IDs",
  "data-mgmt-node-widget-numbers-unit2": "ノード",
  "data-mgmt-node-widget-numbers-unit3": "レコード",
  "data-mgmt-node-widget-capacity": "利用量",

  "data-mgmt-node-toolbar-save": "保存",
  "data-mgmt-node-toolbar-saving": "保存中",

  "data-mgmt-node-table-col1": "データ項目",
  "data-mgmt-node-table-col2": "単位",
  "data-mgmt-node-table-col3": "小数桁数",
  "data-mgmt-node-table-col4": "欠損補完",
  "data-mgmt-node-table-col6": "更新日時",

  "data-mgmt-node-save-api-success": "ノードの設定が正常に反映されました。",
  "data-mgmt-node-save-api-error": "ノードの設定反映に失敗しました。",

  // Error modal
  "data-mgmt-error-modal-title": "CSVファイル処理エラー",
  "data-mgmt-error-modal-file-label": "ファイル:",
  "data-mgmt-error-modal-error-code-label": "エラーコード:",
  "data-mgmt-unknown-error": "不明なエラー",

  // ID CODE
  "data-mgmt-idcode-toolbar-export": "エクスポート",
  "data-mgmt-idcode-toolbar-save": "保存",

  "data-mgmt-idcode-table-col1": "IDコード",
  "data-mgmt-idcode-table-col2": "連携コード",
  "data-mgmt-idcode-table-col3": "ステータス",
  "data-mgmt-idcode-table-col4": "グループ",

  "data-mgmt-idcode-save-api-success":
    "識別コードの設定が正常に反映されました。",
  "data-mgmt-idcode-save-api-error": "識別コードの設定反映に失敗しました。",

  "data-mgmt-idcode-api-success1": "識別コードが正常に削除されました。",
  "data-mgmt-idcode-api-success2": "グループが正常に適応されました。",
  "data-mgmt-idcode-api-success3": "識別コードが正常に発行されました。",

  "data-mgmt-idcode-export-success": "正常にエクスポートされました。",

  "data-mgmt-idcode-api-error1": "識別コード削除が正常に行われませんでした。",
  "data-mgmt-idcode-api-error2": "グループ適応が正常に行われませんました。",
  "data-mgmt-idcode-api-error3": "入力されていない項目があります。",
  "data-mgmt-idcode-api-error4": "識別コードの発行に失敗しました。",

  "data-mgmt-idcode-export-error": "エクスポートに失敗しました",

  // GROUP
  "data-mgmt-group-toolbar-add": "グループ追加",

  "data-mgmt-group-table-col1": "名前",
  "data-mgmt-group-table-col2": "説明",

  "data-mgmt-group-api-success1": "グループが正常に追加されました。",
  "data-mgmt-group-api-success2": "グループが正常に削除されました。",

  "data-mgmt-group-api-error1": "グループ追加が正常に行われませんでした。",
  "data-mgmt-group-api-error2": "グループ削除が正常に行われませんでした。",
  "data-mgmt-group-api-error3": "入力されていない項目があります。",

  "data-mgmt-group-add-dialog-title": "グループ追加",
  "data-mgmt-group-add-dialog-disc":
    "反映するにはグループ追加ボタンを押してください。",
  "data-mgmt-group-add-dialog-item1": "名前",
  "data-mgmt-group-add-dialog-item2": "説明",
  "data-mgmt-group-add-dialog-submit": "グループ追加",

  "data-mgmt-group-delete-dialog-title": "グループ削除",
  "data-mgmt-group-delete-dialog-disc":
    "反映するにはグループ削除ボタンを押してください。",
  "data-mgmt-group-delete-dialog-item1": "名前",
  "data-mgmt-group-delete-dialog-item2": "説明",
  "data-mgmt-group-delete-dialog-submit": "グループ削除",

  // PRIOR
  "data-mgmt-prior-home-title": "事前ルール",

  "data-mgmt-prior-table-col1": "名前",
  "data-mgmt-prior-table-col2": "説明",
  "data-mgmt-prior-table-col3": "ステータス",
  "data-mgmt-prior-table-col4": "禁止項目",
  "data-mgmt-prior-table-col5": "更新日時",
  "data-mgmt-prior-table-col6": "保存日時",

  "data-mgmt-prior-api-loading": "事前ルール設定の検証中です。",
  "data-mgmt-prior-api-success-activate":
    "事前ルールの有効化が正常に完了しました。",
  "data-mgmt-prior-api-success-deactivate":
    "事前ルールの有効化が無効化に完了しました。",
  "data-mgmt-prior-api-success-delete":
    "事前ルールの削除が正常に完了しました。",
  "data-mgmt-prior-api-error": "事前ルール設定の反映に失敗しました。",

  // PRIOR - EXTRACT
  "data-mgmt-prior-extract-toolbar": "因果関係抽出",
  "data-mgmt-prior-extract-title": "因果関係抽出結果",
  "data-mgmt-prior-extract-consent-title": "因果関係候補選択",

  "data-mgmt-prior-extract-deleting": "削除中",
  "data-mgmt-prior-extract-delete": "削除",

  "data-mgmt-prior-extract-table-col1": "原因",
  "data-mgmt-prior-extract-table-col2": "結果",
  "data-mgmt-prior-extract-table-col3": "セクション",
  "data-mgmt-prior-extract-table-col4": "ステータス",
  "data-mgmt-prior-extract-table-col5": "説明",
  "data-mgmt-prior-extract-table-col6": "保存日時",

  "data-mgmt-prior-extract-api-success": "因果関係の削除が正常に完了しました。",
  "data-mgmt-prior-extract-api-error": "因果関係の削除に失敗しました。",

  "data-mgmt-prior-extract-concent-api-success":
    "因果関係候補の保存が正常に完了しました。",
  "data-mgmt-prior-extract-concent-api-error":
    "因果関係候補の保存に失敗しました。",

  "data-mgmt-prior-extract-dialog-trigger": "因果候補追加",
  "data-mgmt-prior-extract-dialog-title": "類似用語検索",

  "data-mgmt-prior-extract-dialog-field1-title": "アウトカム",
  "data-mgmt-prior-extract-dialog-field1-button1": "検索",
  "data-mgmt-prior-extract-dialog-field1-button2": "検索中",

  "data-mgmt-prior-extract-dialog-field1-valid1": "入力必須項目です。",
  "data-mgmt-prior-extract-dialog-field1-valid2":
    "64文字以内で入力してください。",
  "data-mgmt-prior-extract-dialog-field1-valid3":
    "不正な文字が含まれています。",

  "data-mgmt-prior-extract-dialog-api1-loading": "類似用語を検索中です。",
  "data-mgmt-prior-extract-dialog-api1-success1":
    "正常に類似用語を取得できました。",
  "data-mgmt-prior-extract-dialog-api1-success2":
    "類似用語が取得できませんでした、アウトカム名を変更してみてください。",
  "data-mgmt-prior-extract-dialog-api1-error":
    "正常に類似用語を取得できませんでした。",

  "data-mgmt-prior-extract-dialog-field2-title": "類似用語",

  "data-mgmt-prior-extract-dialog-api2-loading": "因果関係候補を取得中です。",
  "data-mgmt-prior-extract-dialog-api2-success1":
    "因果関係候補の取得が正常に完了しました。",
  "data-mgmt-prior-extract-dialog-api2-success2":
    "因果関係候補が存在しませんでした、前のセクションに戻り類似用語の選択を変更してみてください。",
  "data-mgmt-prior-extract-dialog-api2-error":
    "因果関係候補の取得に失敗しました。",

  "data-mgmt-prior-extract-dialog-submit": "次へ",

  "data-mgmt-prior-extract-concent-saving": "保存中",
  "data-mgmt-prior-extract-concent-save": "保存",

  "data-mgmt-prior-extract-concent-empty-desc":
    "すでに全てのエッジ候補が保存済みか、因果関係候補が存在しない可能性があります。",
  "data-mgmt-prior-extract-concent-empty-button": "戻る",

  // PRIOR - ASSIGN
  "data-mgmt-prior-assign-toolbar": "ノード割当て",
  "data-mgmt-prior-assign-title": "ノード割当て",

  "data-mgmt-prior-assign-table-col1": "原因",
  "data-mgmt-prior-assign-table-col2": "結果",
  "data-mgmt-prior-assign-table-col3": "禁止項目",
  "data-mgmt-prior-assign-table-col4": "説明",

  "data-mgmt-prior-assign-api-success": "ノードの割当てが正常に完了しました。",
  "data-mgmt-prior-assign-api-error": "ノードの割当てに失敗しました。",

  "data-mgmt-prior-assign-save": "保存",
  "data-mgmt-prior-assign-saving": "保存中",

  // PRIOR - SETTING
  "data-mgmt-prior-settings-toolbar": "事前ルール追加",
  "data-mgmt-prior-settings-title": "事前ルール設定",

  "data-mgmt-prior-settings-table-col1": "原因",
  "data-mgmt-prior-settings-table-col2": "結果",
  "data-mgmt-prior-settings-table-col3": "ステータス",
  "data-mgmt-prior-settings-table-col4": "説明",

  "data-mgmt-prior-settings-discard": "破棄",
  "data-mgmt-prior-settings-discard-desc":
    "設定を破棄しトップページに戻ります。",
  "data-mgmt-prior-settings-back": "戻る",
  "data-mgmt-prior-settings-next": "次へ",
  "data-mgmt-prior-settings-save": "保存",
  "data-mgmt-prior-settings-saving": "保存中",

  "data-mgmt-prior-settings-section1-title": "タイトル設定",
  "data-mgmt-prior-settings-section1-field1-title": "タイトル",
  "data-mgmt-prior-settings-section1-field1-validate1": "入力必須項目です。",
  "data-mgmt-prior-settings-section1-field1-validate2":
    "64文字以内で入力してください。",
  "data-mgmt-prior-settings-section1-field1-validate3":
    "不正な文字が含まれています。",
  "data-mgmt-prior-settings-section1-field2-title": "説明",
  "data-mgmt-prior-settings-section1-field2-validate1":
    "64文字以内で入力してください。",
  "data-mgmt-prior-settings-section1-field2-validate2":
    "不正な文字が含まれています。",

  "data-mgmt-prior-settings-section1-button1": "破棄",
  "data-mgmt-prior-settings-section1-button2": "次へ",

  "data-mgmt-prior-settings-section2-title": "因果関係選択",

  "data-mgmt-prior-settings-section2-button1": "戻る",
  "data-mgmt-prior-settings-section2-button1-desc":
    "前のセクションに戻ります。",
  "data-mgmt-prior-settings-section2-button2": "破棄",
  "data-mgmt-prior-settings-section2-button3": "次へ",

  "data-mgmt-prior-settings-section3-title": "プレビュー",

  "data-mgmt-prior-settings-section3-api-loading":
    "事前ルール設定を保存中です。",
  "data-mgmt-prior-settings-section3-api-success":
    "事前ルール設定の保存が正常に完了しました。",
  "data-mgmt-prior-settings-section3-api-error":
    "事前ルール設定の保存に失敗しました。",

  "data-mgmt-prior-settings-section3-button1": "戻る",
  "data-mgmt-prior-settings-section3-button1-desc":
    "前のセクションに戻ります。",
  "data-mgmt-prior-settings-section3-button2": "破棄",
  "data-mgmt-prior-settings-section3-button3-1": "保存",
  "data-mgmt-prior-settings-section3-button3-2": "保存中",

  "data-mgmt-prior-settings-notfound-desc":
    "ノード割り当てを完了させるか、新たに事前ルールを追加してください。",
  
  "data-mgmt-attr-select": "選択",
  "data-mgmt-attr-item": "項目名",
  "data-mgmt-attr-unique": "ユニーク値",
  "data-mgmt-attr-type": "型",
  "data-mgmt-main-tab5": "層別化属性",
  "data-mgmt-main-tab6": "時間粒度",
  "data-mgmt-settings-attr-title": "層別化属性の変更",
  "data-mgmt-settings-attr-note": "変更すると、取り込み済みのデータを同じソースから作り直します (新しい版が作られ、完了するまで現在のデータがそのまま使われます)。",
  "data-mgmt-settings-attr-desc": "層別化に使う項目をちょうど 2 つ選んでください。文字列の項目は自動で属性になります。",
  "data-mgmt-settings-attr-submit": "変更してデータを作り直す",
  "data-mgmt-settings-attr-toast-success": "データの作り直しを開始しました。完了までしばらくお待ちください。",
  "data-mgmt-settings-grain-title": "時間粒度の追加",
  "data-mgmt-settings-grain-note": "現在のデータに粒度を追加できます。生成済みの粒度の削除と、最小粒度の変更はできません (取り込みからやり直す必要があります)。",
  "data-mgmt-settings-grain-desc": "追加したい粒度にチェックを入れてください。生成済みの粒度は外せません。",
  "data-mgmt-settings-grain-submit": "粒度を追加する",
  "data-mgmt-settings-grain-toast-success": "粒度の追加を開始しました。完了までしばらくお待ちください。",
  "data-mgmt-settings-grain-generating": "生成中",
  "data-mgmt-settings-grain-generating-note": "粒度を生成しています。この画面を離れても処理は続きます。",
  "data-mgmt-settings-grain-toast-done": "粒度の追加が完了しました。",
  "data-mgmt-settings-grain-toast-failed": "粒度の生成に失敗しました。",
  "data-mgmt-settings-grain-toast-timeout": "粒度の生成に時間がかかっています。処理は続いているため、しばらくしてから画面を開き直してご確認ください。",
  "data-mgmt-settings-agg-title": "集約方法",
  "data-mgmt-settings-agg-desc": "粒度へまとめるときの方法をノードごとに選んでください。追加する粒度に加えて、生成済みの粒度も最小粒度から選んだ方法で作り直します (最小粒度そのものは作り直しません)。選んだ方法は保存され、以後のデータ追加でも使われます。",
  "data-mgmt-settings-agg-col-name": "ノード名",
  "data-mgmt-settings-agg-col-method": "集約方法",
  "data-mgmt-settings-agg-error": "ノードの取得に失敗しました。",
  "data-mgmt-grain-agg-mean": "平均値",
  "data-mgmt-grain-agg-median": "中央値",
  "data-mgmt-grain-agg-max": "最大値",
  "data-mgmt-grain-agg-min": "最小値",
  "data-mgmt-grain-agg-sum": "合計値",
  "data-mgmt-settings-no-data": "変更できるデータがありません。先にデータを取り込んでください (旧方式で取り込まれたデータは変更できません)。",

  // Setup guard (csv-storage-status)
  "setup-guard-title": "解析の準備が完了していません",
  "setup-guard-failed-title": "データの取り込みに失敗しました",
  "setup-guard-upload-body": "CSVデータをアップロードしてください",
  "setup-guard-upload-button": "データをアップロード",
  "setup-guard-processing-body": "データを取り込み中です。しばらくお待ちください",
  "setup-guard-canceled-body": "データが無効化されています。有効化してください",
  "setup-guard-canceled-button": "データ管理へ",
  "setup-guard-imputation-body": "データ管理のノード設定を保存してください",
  "setup-guard-imputation-note": "※変更がなくても保存が必要です",
  "setup-guard-imputation-button": "ノード設定へ",
  "setup-guard-discretization-body": "データ管理の因果推論データ設定を保存してください",
  "setup-guard-discretization-button": "因果推論データ設定へ",
  "setup-guard-discretization-running-body": "設定を反映中です。しばらくお待ちください",
  "setup-guard-failed-imputation-body": "ノード設定の保存に失敗しました",
  "setup-guard-failed-discretization-body": "因果推論データ設定の保存に失敗しました",
  "setup-guard-failed-store-body": "データの取り込みに失敗しました。アップロードをやり直してください",
  "setup-guard-failed-detail-button": "詳細を表示",
  "setup-guard-failed-code-label": "エラーコード",
};

export default dataManager;
